import { Button, Flex, Modal, Table, Typography, Tooltip, message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddFamilyMemberForm from "./AddFamilyMemberForm";
import {
  fetchMemberList,
  deleteMemberData,
} from "../store/reducers/customerReducer";
import { DeleteTwoTone, ExclamationCircleFilled } from "@ant-design/icons";
import LoadingSpinner from "./Loader";
import dayjs from "dayjs";

const { confirm } = Modal;

const { Text } = Typography;

// Component for displaying Family Members of Customer.
const FamilyMemberTable = ({ customer }) => {
  const [isFamilyMemberFormVisible, setFamilyMemberFormVisible] =
    useState(false);
  const customerMemberList = useSelector(
    (state) => state?.customer?.customerMemberList
  );
  const activeAccount = useSelector((state) => state?.auth?.activeAccount);
  const agentAuthToken = useSelector((state) => state?.auth?.token);

  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);

  const showDeleteConfirm = (record) => {
    confirm({
      title: "Are you sure remove this Member?",
      icon: <ExclamationCircleFilled />,
      content: "Removed members cannot be restored.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setUploading(true);
        const data = { ...record, customerId: customer?.customerId };
        dispatch(deleteMemberData(data)).then((response) => {
          if (response?.payload?.success === true) {
            dispatch(fetchMemberList(data)).then((result) => {
              if (result?.payload?.success === true) {
                setUploading(false);
                message.success("Member Deleted Successfully");
              } else {
                setUploading(false);
                message.success("Member Deleted Successfully");
              }
            });
          } else {
            setUploading(false);
            message.error("Something went wrong, please try again later");
          }
        });
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "memberName",
      key: "memberName",
      render: (_, record) => (
        <>
          {record?.firstName} {record?.lastName}
        </>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
      render: (_, record) => {
        return <>{record?.phone}</>;
      },
    },
    {
      title: "Date of Birth",
      dataIndex: "memberDOB",
      key: "memberDOB",
      render: (_, record) => {
        return (
          <>
            {record?.dateOfBirth
              ? dayjs(record?.dateOfBirth).format("DD-MMMM-YYYY")
              : "Not Available"}
          </>
        );
      },
    },
    {
      title: "Relation",
      dataIndex: "relation",
      key: "relation",
      render: (_, record) => {
        return <>{record?.relation}</>;
      },
    },
    {
      title: "Action",
      dataIndex: "memberUrl",
      key: "memberUrl",
      render: (_, record) => (
        <Flex gap={16}>
          {/* <Tooltip title={"Delete Member"}>
            <Button onClick={() => showDeleteConfirm(record)}>
              <DeleteTwoTone twoToneColor="#dc3545" />
            </Button>
          </Tooltip> */}
        </Flex>
      ),
    },
  ];

  useEffect(() => {
    setUploading(true);
    const data = { accountId: activeAccount?.id, token: agentAuthToken };
    dispatch(fetchMemberList(data)).then((response) => {
      if (response?.payload?.data?.success === true) {
        setUploading(false);
      } else {
        setUploading(false);
      }
    });
  }, [customer, dispatch, activeAccount]);

  return (
    <>
      <AddFamilyMemberForm
        visible={isFamilyMemberFormVisible}
        setVisible={setFamilyMemberFormVisible}
        customer={customer}
      />

      <LoadingSpinner loading={uploading} />
      <Table
        columns={columns}
        dataSource={customerMemberList}
        pagination={false}
        scroll={{
          y: 170,
        }}
        title={() => {
          return (
            <Flex dir="row" justify={"space-between"}>
              <Text style={{ fontWeight: 600, fontSize: 16 }}>Members</Text>
              <Button
                type="primary"
                onClick={() => {
                  setFamilyMemberFormVisible(true);
                }}
              >
                Add Member
              </Button>
            </Flex>
          );
        }}
      />
    </>
  );
};

export default FamilyMemberTable;
